(function($) {
  const homepageTextImage = Array.from(document.querySelectorAll(
    ".content-text-image--left, .content-text-image--right"
  ));

  /**
   * @description - Function checks if element is in the viewport and adds appropriate class to it.
   */
  const showImageWhenInViewport = function(item) {
    const show = debounce(item => {
      if (item && isInViewport(item)) {
        item.classList.add("in-viewport");
      }
    }, 30);
    show(item);
  };

  /**
   * Initialize functions on start and on scroll
   */
  $(window).on("scroll touchmove", function() {
    homepageTextImage.forEach(function(item) {
      showImageWhenInViewport(item);
    });
  });

  $(document).ready(() => {
    homepageTextImage.forEach(function(item) {
      showImageWhenInViewport(item);
    });
  });
})(jQuery);
